import { ArrowLeft, Lock } from 'lucide-react';
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { OMNITRACKER_URL } from '@/constants/omnitracker';
import { useVorgangLockContext } from '@/features/vorgangLocking/VorgangLockProvider';
import { PowercloudButtonLink } from '@/pages/VorgangBearbeitung/components/PowercloudButtonLink';
import type { VorgangDetail } from '@/types';

interface VorgangHeaderProps {
  vorgang: VorgangDetail;
  hasUnsavedChanges: boolean;
  isArchived: boolean;
  onBack: () => void;
}

export const VorgangHeader: React.FC<VorgangHeaderProps> = ({
  vorgang,
  hasUnsavedChanges,
  isArchived,
  onBack,
}) => {
  const { isLockedByCurrentUser, isLockedByOtherUser, lockedBy } =
    useVorgangLockContext();

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={onBack}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Zurück
        </Button>
        <h1 className="text-2xl font-bold text-text-primary">
          Vorgang bearbeiten
        </h1>
      </div>

      <div className="flex items-center gap-3">
        {hasUnsavedChanges && (
          <Badge
            variant="outline"
            className="text-yellow-600 border-yellow-600"
          >
            Ungespeicherte Änderungen
          </Badge>
        )}
        {isArchived && (
          <Badge variant="outline" className="text-blue-600 border-blue-600">
            Archivierter Vorgang
          </Badge>
        )}

        <PowercloudButtonLink vorgang={vorgang} />

        <Button variant="outline" size="sm" asChild className="text-sm">
          <a href={OMNITRACKER_URL} target="_blank" rel="noopener noreferrer">
            Fehlerticket erstellen
          </a>
        </Button>

        {isLockedByCurrentUser && (
          <Badge variant="default" className="bg-green-600">
            <Lock className="h-3 w-3 mr-1" />
            Gesperrt für Sie
          </Badge>
        )}

        {isLockedByOtherUser && (
          <Badge variant="destructive">
            <Lock className="h-3 w-3 mr-1" />
            Gesperrt von {lockedBy}
          </Badge>
        )}
      </div>
    </div>
  );
};
